import { useDispatch } from "react-redux"

import { downloadMusicFile } from "../../../Store/Formulaire/Actions"

export const useDownloadMusic = () => {
    const dispatch = useDispatch()

    const handleDownloadMusic = (music_id: number) => {
        dispatch(downloadMusicFile(music_id))
    }

    return {
        handleDownloadMusic
    }
}